var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gf-user-avatar-cropper"},[(_vm.currentAvatar)?_c('gf-image-cropper',{attrs:{"selected-image-source":_vm.currentAvatar,"preview-width":"120px","is-rounded-crop":true,"input-name":"avatar"},on:{"setDefault":_vm.setDefaultAvatar}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }